import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "../../../../components/input";
import {
  createCampaign,
  getCampaign,
  updateCampaign,
} from "../../../../services/axios";

export function CreateCampaign({ cid }: { cid?: string }) {
  let history = useHistory();
  const [campaign, setCampaign] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!cid) {
      return;
    }
    setCampaign(cid);
  }, [cid]);

  useEffect(() => {
    if (!cid) {
      return;
    }
    getData(cid);
  }, [cid]);

  const create = async () => {
    if (campaign) {
      let result = await createCampaign({ id: campaign });
      if (!result) {
        toast.error("error");
      }
      toast.success("saved");
      history.push({
        pathname: `/campaign/${campaign}`,
      });
    }
  };

  const update = async () => {
    if (!campaign) {
      return;
    }
    let result = await updateCampaign(campaign, {
      id: campaign,
      campaign: campaign,
      title: title,
      description: description,
    });
    if (!result) {
      toast.error("error");
    }
    toast.success("saved");
    getData(campaign);
    return result;
  };

  async function getData(cid: string) {
    if (!cid) {
      return;
    }
    const req = await getCampaign(cid);
    if (!req) {
      return;
    }
    setTitle(req.title);
    setDescription(req.description);
  }

  return (
    <div className="w-full p-8 m-4 border rounded">
      {cid ? (
        <div className="flex-1 min-w-0">
          <div className="flex-1 min-w-0 w-full">
            <h4 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
              Campaign {cid}
            </h4>
          </div>
          <div className="grid grid-cols-1 gap-4 mt-8">
            <Input
              label="Title: {campaign-title}"
              placeholder="ex: 12345"
              field="title"
              value={title}
              onChange={(field: string, e: any) => {
                setTitle(e.target.value);
              }}
            />
            <Input
              label="Description: {campaign-description}"
              placeholder="ex: 12345"
              field="description"
              value={description}
              onChange={(field: string, e: any) => {
                setDescription(e.target.value);
              }}
            />
          </div>
          <div className="flex-1 min-w-0">
            <button
              onClick={() => update()}
              className="bg-black px-4 py-2 text-white my-4"
            >
              Update
            </button>
          </div>
        </div>
      ) : (
        <div className="w-max-7xl">
          <div className="flex-1 min-w-0">
            <h4 className="text-lg font-bold leading-7 text-gray-900 sm:text-xl sm:truncate">
              Create Campaign
            </h4>
          </div>
          <div className="mt-1 space-y-8">
            <input
              onChange={(e) => setCampaign(e.target.value)}
              type="text"
              name="campaign"
              id="campaign"
              value={campaign}
              placeholder="Campaign ID"
            />
          </div>
          <div className="flex-1 min-w-0">
            <button
              onClick={() => create()}
              className="bg-black px-4 py-2 text-white my-4"
            >
              Create
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
